import * as React from "react";
const TranslateIcone = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={27}
    height={28}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M2 4.824h10.063M9.187 2v2.824C9.188 11.06 5.97 16.118 2 16.118m1.438-5.647c0 3.026 4.243 5.517 9.63 5.647M13.5 26l5.75-12.706L25 26m-1.293-2.823h-8.913"
    />
  </svg>
);
export default TranslateIcone;
